import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import '../AdminLogin/AdminLogin.css';
import { useNavigate } from 'react-router-dom';

function AdminLogin() {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        const { email, password } = credentials;
        const adminEmail = 'admin@badskullgaming.com';
        const adminPassword = 'BossAdmin123';

        if (email === adminEmail && password === adminPassword) {
            toast.success('Login Successful!');
            // Simulating authentication and setting session storage
            localStorage.setItem('isLoggedIn', 'true');
            setTimeout(() => {
                navigate('/Dashboard');  // Redirects user to the admin dashboard
            }, 2000);  // Delay to allow the toast to be seen
        } else {
            toast.error('Invalid email or password');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    return (
        <Container className="d-flex vh-100" style={{
            backgroundImage: 'url(https://www.badskullgaming.com/static/media/logowithsideimg.d391825a8851e2c4b5f3.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }}>
            <Row className="m-auto align-self-center w-100">
                <Col xs={12} md={6} lg={4} className="m-auto">
                    <Form onSubmit={handleSubmit} className="p-4 border rounded bg-dark text-light">
                        <h2 className="mb-3 text-center" style={{ color: '#d4af37' }}>Admin Login</h2>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                value={credentials.email}
                                onChange={handleChange}
                                name="email"
                            />
                        </Form.Group>
                        <Form.Group controlId="formBasicPassword" className="mt-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Password"
                                value={credentials.password}
                                onChange={handleChange}
                                name="password"
                            />
                        </Form.Group>
                        <Button variant="warning" type="submit" className="mt-3 w-100">
                            Login
                        </Button>
                    </Form>
                </Col>
            </Row>
            <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Container>
    );
}

export default AdminLogin;
